// Svitlana


import saveTheChildren1x from '/src/images/support-img/save-the-children@1x.png';
import saveTheChildren2x from '/src/images/support-img/save-the-children@2x.png';
import projectHOPE1x from '/src/images/support-img/project-hope@1x.png';
import projectHOPE2x from '/src/images/support-img/project-hope@2x.png';
import united241x from '/src/images/support-img/united24@1x.png';
import united242x from '/src/images/support-img/united24@2x.png';
import internationalMedicalCorps1x from '/src/images/support-img/medical-corps@1x.png';
import internationalMedicalCorps2x from '/src/images/support-img/medical-corps@2x.png';
import medicinsSansFrontieres1x from '/src/images/support-img/medecins-sans@1x.png';
import medicinsSansFrontieres2x from '/src/images/support-img/medecins-sans@2x.png';
import razom1x from '/src/images/support-img/razom@1x.png';
import razom2x from '/src/images/support-img/razom@2x.png';
import serhiyPrytula1x from '/src/images/support-img/sergiy-prytula@1x.png';
import serhiyPrytula2x from '/src/images/support-img/sergiy-prytula@2x.png';
import actionAgainsthunger1x from '/src/images/support-img/action-against-hunger@1x.png';
import actionAgainsthunger2x from '/src/images/support-img/action-against-hunge@2x.png';
import worldvision1x from '/src/images/support-img/world-vision@1x.png';
import worldvision2x from '/src/images/support-img/world-vision@2x.png';



export const supportArray = [
  {
    title: 'Save the Children',
    url:
      'https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis',
    img1x: saveTheChildren1x,
    img2x: saveTheChildren2x,
  },
  {
    title: 'Project HOPE',
    url: 'https://www.projecthope.org/country/ukraine/',
    img1x: projectHOPE1x,
   img2x:projectHOPE2x,
  },
  {
    title: 'UNITED24',
    url: 'https://u24.gov.ua/uk',
    img1x: united241x,
    img2x: united242x,
  },
  {
    title: 'International Medical Corps',
    url: 'https://internationalmedicalcorps.org/country/ukraine/',
    img1x: internationalMedicalCorps1x,
    img2x: internationalMedicalCorps2x,
  },
  {
    title: 'Medicins Sans Frontieres',
    url: 'https://www.msf.org/ukraine',
    img1x: medicinsSansFrontieres1x,
    img2x:medicinsSansFrontieres2x,
  },
  {
    title: 'RAZOM',
    url: 'https://www.razomforukraine.org/',
    img1x: razom1x,
    img2x:razom2x,
  },
  {
    title: 'Action against hunger',
    url: 'https://www.actionagainsthunger.org/location/europe/ukraine/',
    img1x: actionAgainsthunger1x,
    img2x:actionAgainsthunger2x,
  },
  {
    title: 'World vision',
    url: 'https://www.wvi.org/emergencies/ukraine',
    img1x: worldvision1x,
    img2x:worldvision2x,
  },
  {
    title: 'Serhiy Prytula Charity Foundation',
    url: 'https://prytulafoundation.org/en',
    img1x: serhiyPrytula1x,
    img2x:serhiyPrytula2x,
  },
]

